export const CONSULTANT_CLASS_ID = 'CONSULTANT' as const
